module.exports = __webpack_public_path__ + "static/media/bus-ticket.cfa9cb6b.gif";